import builder from './builder';
import TripsWithMeetAndGreet from './commons/TripsWithMeetAndGreet/Mobile';

export default builder({
  MeetAndGreetSuggestionsComponent: TripsWithMeetAndGreet
});
